<template>
	<v-row dense no-gutters align-content="center" align="center" class="acao-voltar">
		<az-back-button
			id="azBackButton"
			:route="{ name: nomeRotaAnterior }"
			:text="labelVoltar"
			@Click="voltarPara()"
		></az-back-button>
		<v-spacer></v-spacer>
	</v-row>
</template>
<script>
export default {
	name: 'botao-voltar',
	props: {
		nomeRotaAnterior: {
			type: String,
			default: '',
		},
		parametrosDaRota: {
			type: Object,
			default: null,
		},
		labelVoltar: {
			type: String,
			default: '',
		},
	},
	methods: {
		voltarPara() {
			this.$router.push({ name: this.nomeRotaAnterior, params: this.parametrosDaRota })
		},
	},
}
</script>
